if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      abortController = undefined;
      onVariantChangeUnsubscriber = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      cartUpdateUnsubscriber = undefined;

      constructor() {
        super();
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();

        this.currentVariant = this.getSelectedVariant(this);
        if (this.currentVariant) {
          this.updateMedia(this.currentVariant);
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
        const viewMode = this.dataset.viewMode || 'main-product';

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage, viewMode)
            : this.handleUpdateProductInfo(productUrl, viewMode),
        });
      }

      handleSwapProduct(productUrl, updateFullPage, viewMode) {
        return (html) => {
          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }
          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));

          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
            HTMLUpdateUtility.viewTransition(
              document.getElementById('shopify-section-sticky-atc-bar'),
              html.getElementById('shopify-section-sticky-atc-bar'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }

          this.currentVariant = variant;
        };
      }

      handleUpdateProductInfo(productUrl, viewMode) {
        return (html) => {
          const initTabs = () => {
              const subscriptionPlanMapping = JSON.parse(html.getElementById('tab_script').text.match(/subscriptionPlanMapping\s*=\s*({[\s\S]*?})/)[1].replace(/,\s*}/g, "}"))

              function selectInterval(value) {
                selectedSubscriptionInterval = value;
                document
                  .querySelector(`[data-plan-id="${subscriptionPlanMapping[`${selectedSubscription}_${value}`]}"]`)
                  .click();
                document.querySelector('input[name="selling_plan"]').value =
                  subscriptionPlanMapping[`${selectedSubscription}_${value}`];
                document
                  .querySelector(`[data-plan-id="${subscriptionPlanMapping[`${selectedSubscription}_0`]}"]`)
                  .classList.add('paywhirl-plan-selector-selected');
              }

              const einmaligRadio = document.getElementById('einmalig');
              const aboRadio = document.getElementById('abo');
              const quantityInput = document.querySelector('#custom-paywhirl-quantity-input');
              const plans = document.querySelectorAll('.paywhirl-plan-selector-plans label');

              let singleSub = null;
              let doubleSub = null;
              let tripleSub = null;
              plans.forEach((item, index) => {
                if (index === 0) {
                  singleSub = item;
                } else if (index === 1) {
                  doubleSub = item;
                } else if (index === 2) {
                  tripleSub = item;
                } else {
                  item.setAttribute('style', 'display:none !important');
                }
              });

              // ➕ "pro Stück" unter jede Spar-Abo-Option einfügen
              plans.forEach((item, index) => {
                if (!item.querySelector('.pro-stueck-info')) {
                  const price = item.querySelector('.paywhirl-price');
                  if (price) {
                    const span = document.createElement('span');
                    span.textContent = 'pro Stück';
                    span.className = 'pro-stueck-info';
                    span.style.fontSize = '13px';
                    span.style.color = '#777';
                    span.style.display = 'block';
                    span.style.marginTop = '4px';
                    price.after(span);
                  }
                }
                if (index > 0) {
                  const badge = document.createElement('span');
                  const originalPrice = +item
                    .querySelector('.paywhirl-plan-selector-price > .paywhirl-compare-at-price')
                    .textContent.replace('€', '')
                    .replace(',', '.');
                  const discountedPrice = +item
                    .querySelector('.paywhirl-plan-selector-price > .paywhirl-price')
                    .textContent.replace('€', '')
                    .replace(',', '.');
                  const discount = Math.round(((originalPrice - discountedPrice) / originalPrice) * 100);
                  badge.textContent = `-${discount}%`;
                  badge.className = 'discount-badge';
                  item.appendChild(badge);
                }
              });

              const buyOnceItems = document.querySelectorAll('.buy-once-item');

              const subscriptionIntervalContainer = document.getElementById('subscriptionInterval');
              subscriptionIntervalContainer.style.display = 'none';

              let quantityBreakSection = document.querySelector('#buyOnce');
              let paywhirlSection = document.querySelector('.paywhirl-plan-selector');
              let buyButtonSection = document.querySelector('.buy-button-section');
              let iconWithTextSection = document.querySelector('.icon-with-text-section');
              if (paywhirlSection) {
                paywhirlSection.classList.add('paywhirl-hidden');
              }

              function toggleSections() {
                quantityBreakSection = document.querySelector('#buyOnce');
                paywhirlSection = document.querySelector('.paywhirl-plan-selector');
                buyButtonSection = document.querySelector('.buy-button-section');
                iconWithTextSection = document.querySelector('.icon-with-text-section');
                if (einmaligRadio.checked) {
                  if (quantityBreakSection) quantityBreakSection.style.display = 'flex';
                  if (paywhirlSection) paywhirlSection.classList.add('paywhirl-hidden');
                  subscriptionIntervalContainer.style.display = 'none';
                  buyButtonSection.classList.remove('custom-paywhirl-margin');
                  buyButtonSection.classList.remove('custom-paywhirl-background');
                  iconWithTextSection.classList.remove('custom-paywhirl-background');

                  buyOnceItems[0].click();
                } else {
                  if (quantityBreakSection) quantityBreakSection.style.display = 'none';
                  if (paywhirlSection) paywhirlSection.classList.remove('paywhirl-hidden');
                  subscriptionIntervalContainer.style.removeProperty('display');
                  paywhirlSection.after(iconWithTextSection);
                  paywhirlSection.after(buyButtonSection);
                  buyButtonSection.classList.add('custom-paywhirl-margin');
                  buyButtonSection.classList.add('custom-paywhirl-background');
                  iconWithTextSection.classList.add('custom-paywhirl-background');

                  singleSub.click();
                }
              }

              function setBuyOnceItem(item) {
                buyOnceItems.forEach((v) => v.classList.remove('selected'));
                item.classList.toggle('selected');
                quantityInput.value = item.dataset.quantity;
                const sellingPlanInput = document.querySelector('[name="selling_plan"]');
                if (sellingPlanInput) {
                  sellingPlanInput.value = '';
                }
                //Set Product price on page
                document.querySelector('.f-price-item.f-price-item--regular').textContent =
                  item.querySelector('.price').textContent.replace('€', '');
                if (item.dataset.quantity === '1' ) {
                  document.querySelector('.old-price').textContent = '';
                  document.querySelector('.old-price').style.display = 'none';
                  document.querySelector('.old-price').style.marginRight = '0px';
                } else {
                  document.querySelector('.old-price').style.marginRight = '';
                  document.querySelector('.old-price').style.display = '';
                  document.querySelector('.old-price').textContent = `${(
                    +item.querySelector('.prev-price').textContent.replace('€', '').replace(',', '.')
                  )
                    .toFixed(2)
                    .toString()
                    .replace('.', ',')} €`;
                }

                //Set Product price in sticky bar
                document.querySelector(
                  'sticky-atc-bar > div > .sticky-atc-bar__product-info > .f-price > .f-price__regular > .f-price-item.f-price-item--regular'
                ).textContent = item.querySelector('.price').textContent;
                // Set pricePerDay and price per kg
                const pillsPerDays = +document.querySelector('[data-days-divider]').dataset['daysDivider'];
                const pricePerDay = (
                  Number(item.querySelector('.price-displayed').textContent.replace(',', '').replace('€', '')) /
                  100 /
                  pillsPerDays
                ).toFixed(2);

                const templateEl = document.querySelector('#template-data');
                const selector = templateEl.dataset.templateName;

                console.log('Selector aus Metafeld:', selector);

                // Jetzt anwenden:
                document.querySelector(
                  `${selector} > div > .price-badge-wrapper > .price-badge`
                ).textContent = `Nur ${pricePerDay.toString().replace('.', ',')} € pro Tagesdosis`;

                // weight-in-g
                const weightInGrams = +document.querySelector('[data-weight-in-g]').dataset['weightInG'];
                document.querySelector(
                  `${selector} > div > .f-price__unit-wrapper > .f-price__unit > [data-unit-price]`
                ).textContent = `${(
                  (Number(item.querySelector('.price-displayed').textContent.replace(',', '.').replace('€', '')) *
                    1000) /
                  weightInGrams
                )
                  .toFixed(2)
                  .toString()
                  .replace('.', ',')} €`;
                // Set price per day and price per kg in sticky bar document.querySelector('sticky-atc-bar > div > .sticky-atc-bar__product-info > .f-price > .price-badge-wrapper > .price-badge').textContent = `Nur €${pricePerDay.toString().replace(".",",")} pro Tagesdosis`;document.querySelector('sticky-atc-bar > div > .sticky-atc-bar__product-info > .f-price > .f-price__unit-wrapper > .f-price__unit > [data-unit-price]').textContent = `€${((Number(item.querySelector('.price').textContent.replace(",",".").replace("€","")) * 10) / item.dataset.quantity) .toFixed(2).toString().replace(".",",")}`
              }

              function moveDescription() {
                const subscriptionContainer = document.body.querySelector('.paywhirl-plan-selector-group-container');
                const bulletPoints = document.body.querySelector('#subscription-text-data');
                bulletPoints.classList.add('subscription');

                if (subscriptionContainer) {
                  subscriptionContainer.after(bulletPoints);
                  bulletPoints.style.display = '';
                } else {
                  bulletPoints.style.display = 'none';
                }
              }

              einmaligRadio.addEventListener('change', toggleSections);
              aboRadio.addEventListener('change', toggleSections);

              [singleSub, doubleSub, tripleSub].forEach((item, index) => {
                if (item !== null) {
                  item.addEventListener('click', (event) => {
                    selectedSubscription = index;
                    quantityInput.value = (index + 1).toString();
                    if (selectedSubscriptionInterval === -1) {
                      selectInterval(0);
                    } else {
                      selectInterval(selectedSubscriptionInterval);
                    }

                    // "pro Stück" unter dem Preis einfügen
                    const alreadyExists = item.querySelector('.pro-stueck-info');
                    if (!alreadyExists) {
                      const span = document.createElement('span');
                      span.textContent = 'pro Stück';
                      span.className = 'pro-stueck-info';
                      span.style.fontSize = '13px';
                      span.style.color = '#777';
                      span.style.display = 'block';
                      span.style.marginTop = '4px';

                      const priceSpan = item.querySelector('.paywhirl-price');
                      priceSpan?.after(span);
                    }

                    //Set Product price on page
                    document.querySelector('.f-price-item.f-price-item--regular').textContent =
                      (
                        +item.querySelector('.paywhirl-price').textContent.replace('€', '').replace(',', '.') *
                        (index + 1)
                      )
                        .toString()
                        .replace('.', ',') + ' €';
                    if (+item
                          .querySelector('.paywhirl-compare-at-price')
                          .textContent.replace('€', '')
                          .replace(',', '.') === 0 || isNaN(+item
                          .querySelector('.paywhirl-compare-at-price')
                          .textContent.replace('€', '')
                          .replace(',', '.'))) {
                      document.querySelector('.old-price').textContent = '';
                      document.querySelector('.old-price').style.display = 'none';
                      document.querySelector('.old-price').style.marginRight = '0px';
                    } else {
                      document.querySelector('.old-price').style.marginRight = '';
                      document.querySelector('.old-price').style.display = '';
                      console.log(item.querySelector('.paywhirl-compare-at-price'));
                      document.querySelector('.old-price').textContent = `${(
                        +item
                          .querySelector('.paywhirl-compare-at-price')
                          .textContent.replace('€', '')
                          .replace(',', '.') *
                        (index + 1)
                      )
                        .toFixed(2)
                        .toString()
                        .replace('.', ',')} €`;
                    }
                    //Set Product price in sticky bar
                    document.querySelector(
                      'sticky-atc-bar > div > .sticky-atc-bar__product-info > .f-price > .f-price__regular > .f-price-item.f-price-item--regular'
                    ).textContent = item.querySelector('.paywhirl-price').textContent;
                    // Set pricePerDay and price per kg
                    const pillsPerDays = +document.querySelector('[data-days-divider]').dataset['daysDivider'];
                    const pricePerDay = (
                      Number(item.querySelector('.paywhirl-price').textContent.replace(',', '').replace('€', '')) /
                      100 /
                      pillsPerDays
                    ).toFixed(2);

                    const templateEl = document.querySelector('#template-data');
                    const selector = templateEl.dataset.templateName;

                    console.log('Selector aus Metafeld:', selector);

                    // Jetzt anwenden:
                    document.querySelector(
                      `${selector} > div > .price-badge-wrapper > .price-badge`
                    ).textContent = `Nur ${pricePerDay.toString().replace('.', ',')} € pro Tagesdosis`;

                    const weightInGrams = +document.querySelector('[data-weight-in-g]').dataset['weightInG'];

                    document.querySelector(
                      `${selector} > div > .f-price__unit-wrapper > .f-price__unit > [data-unit-price]`
                    ).textContent = `${(
                      (Number(+item.querySelector('.paywhirl-price').textContent.replace('€', '').replace(',', '.')) *
                        1000) /
                      weightInGrams
                    )
                      .toFixed(2)
                      .toString()
                      .replace('.', ',')} €`;
                  });
                }
              });

              buyOnceItems.forEach((item) => item.addEventListener('click', (event) => setBuyOnceItem(item)));

              moveDescription();
              buyOnceItems[0].click();
              setTimeout(() => {
                const sellingPlanInput = document.querySelector('[name="selling_plan"]');
                if (sellingPlanInput) {
                  sellingPlanInput.value = '';
                }
              }, 1000);
            }

          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateShareUrl(variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(variant);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);

            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Badges', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('PricePerItem', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Volume');

          this.updateQuantityRules(this.sectionId, this.productId, html);
          this.querySelector(`#QuantityRules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#VolumeNote-${this.dataset.section}`)?.classList.remove('hidden');

          HTMLUpdateUtility.viewTransition(
            document.querySelector(`#SizeChart-${this.sectionId}`),
            html.querySelector(`#SizeChart-${this.sectionId}`),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );

          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            FoxTheme.variantStrings.soldOut
          );

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

          document.dispatchEvent(
            new CustomEvent('variant:changed', {
              detail: {
                variant: variant,
              },
            })
          );
        };
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      updateVariantInputs(variantId) {
        document
          .querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`)
          .forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = variantId ?? '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
      }

      updateMedia(variant) {
        const productMedia = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
        if (!productMedia) return; // Early return if productMedia is not found

        const setActiveMedia = () => {
          if (typeof productMedia.setActiveMedia === 'function') {
            productMedia.init();
            productMedia.setActiveMedia(variant);
            return true; // Indicate success
          }
          return false; // Indicate failure
        };

        if (!setActiveMedia()) {
          this.timer = setInterval(() => {
            if (setActiveMedia()) {
              clearInterval(this.timer);
            }
          }, 100);
        }
      }

      updateShareUrl(variantId) {
        if (!variantId) return;
        const shareButton = document.getElementById(`ProductShare-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${variantId}`);
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = this.decoded(text);
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = this.decoded(FoxTheme.variantStrings.addToCart);
        }

        if (!modifyClass) return;
      }

      decoded(text) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = text;
        const decoded = tempDiv.textContent;
        return decoded;
      }

      setUnavailable() {
        this.toggleAddButton(true, FoxTheme.variantStrings.unavailable);
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.setQuantityBoundries();
        if (!this.hasAttribute('data-original-section')) {
          this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      setQuantityBoundries() {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries, {
          data: {
            sectionId: this.sectionId,
            productId: this.productId,
          },
        });
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.productIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart')?.classList.add('btn--loading');

        fetch(`${this.getAttribute('data-url')}?variant=${currentVariantId}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.sectionId, this.productId, parsedHTML);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart')?.classList.remove('btn--loading');
          });
      }

      updateQuantityRules(sectionId, productId, parsedHTML) {
        if (!this.quantityInput) return;

        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules, {
          data: {
            sectionId,
            productId,
            parsedHTML,
          },
        });

        this.setQuantityBoundries();
      }
    }
  );
}
